import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { setLocalStorageItem } from "../../../../src/utils/index";
import { Button, Input, message } from "antd";
import { images } from "../../../assets/images";
import { loginApi } from "../../../ApiServices/Apifun"; 

const Login = () => {
  const [userData, setUserData] = useState({ email: "", password: "" });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
 
  const validateForm = () => {
    let tempErrors = {};
    let isValid = true;

    // Email validation
    if (!userData.email.trim()) {
      tempErrors.email = "Email is required";
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(userData.email)) {
      tempErrors.email = "Please enter a valid email address";
      isValid = false;
    }

    // Password validation
    if (!userData.password.trim()) {
      tempErrors.password = "Password is required";
      isValid = false;
    } else if (userData.password.length < 6) {
      tempErrors.password = "Password must be at least 6 characters long";
      isValid = false;
    }

    setErrors(tempErrors);
    return isValid;
  };

  const handlelogin = () => {
    // ✅ Validate before API call
    if (!validateForm()) return;

    setLoading(true);
    const data = {
      loginId: userData.email,
      password: userData.password,
    };

    loginApi(data)
      .then((response) => {

        if (response.status) {
          setLocalStorageItem("token", response.data?.access_token);
          setLocalStorageItem("user", response.data?.user);
          setLocalStorageItem("wallet", response.data?.walletBalance);
          setLocalStorageItem("login", true);
          // navigate("/dashboard");
          // message.success("Vendor Logged In Successfully");
          message.success("Admin Logged In Successfully");
          navigate("/dashboard");
        } else {
          message.error(response.message || "Invalid credentials");
        }
      })
      .catch((error) => {
        console.error(error);
        message.error(error.response.data.message || "Something went wrong. Please try again.");
      })
      .finally(() => setLoading(false));
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") handlelogin();
  };

  return (
    <div className="h-screen px-4 bg-[#fff3f3] flex items-center">
      <div className="w-[1200px] max-w-[100%] mx-auto grid grid-cols-1 md:grid-cols-2 shadow-[-5px_0px_15px_#ddd] rounded-md overflow-hidden">
        
        {/* Left Side - Image */}
        <div className="h-full">
          <img
            src={images.login}
            alt="logo"
            className="object-cover h-full w-full"
          />
        </div>

        {/* Right Side - Form */}
        <div className="p-12 bg-white">
          <p className="text-2xl font-medium mb-6 text-rgbaprimary9">Sign In</p>

          {/* Email Field */}
          <div className="mb-5">
            <label className="block text-rgbaprimary9 text-md font-medium mb-2">
              Email Address
            </label>
            <Input
              type="email"
              name="email"
              placeholder="Enter your email"
              value={userData.email}
              onKeyDown={handleKeyPress}
              onChange={(e) =>
                setUserData({ ...userData, email: e.target.value })
              }
              className={`border rounded w-full py-2 px-3 text-sm ${
                errors.email ? "border-red-500" : "border-gray-300"
              }`}
            />
            {errors.email && (
              <p className="text-red-500 text-xs mt-1">{errors.email}</p>
            )}
          </div>

          {/* Password Field */}
          <div className="mb-7">
            <label className="block text-rgbaprimary9 text-md font-medium mb-2">
              Password
            </label>
            <Input.Password
              name="password"
              placeholder="Enter your password"
              value={userData.password}
              onKeyDown={handleKeyPress}
              onChange={(e) =>
                setUserData({ ...userData, password: e.target.value })
              }
              className={`border rounded w-full py-2 px-3 text-sm ${
                errors.password ? "border-red-500" : "border-gray-300"
              }`}
            />
            {errors.password && (
              <p className="text-red-500 text-xs mt-1">{errors.password}</p>
            )}
          </div>

          {/* Submit Button */}
          <Button
            loading={loading}
            type="primary"
            className="w-full h-10 font-semibold bg-rgbaprimary8"
            onClick={handlelogin}
          >
            Login
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Login;
